/**
 * Implements a switch between networks
 */
import { Link } from 'react-router-dom';
import { Network } from '@kattana-io/common';
import PricingPlans from './PricingPlans';
import Text from '../../../atoms/Text';
import { toFixed4 } from '../../DexTrades/formatters';
import FallbackImage from '../../../atoms/Image/Fallback';
import '../../common/balances-coins-list.scss';
import { switchCurrentTicker } from '../../../Authlogic';
import './styles.scss';

// here's array of scam addresses of tokens whick should not be displayed in the balance menu
const scamAddresses = [
  '0x119e2ad8f0c85c6f61afdf0df69693028cdc10be', // Zepe.io
  '0x17b7163cf1dbd286e262ddc68b553d899b93f526', // QBT
  '0x67efef66a55c4562144b9acfcfbc62f9e4269b3e', // Cake-LP
  '0x8cad27f4a0987ff10a2a14c35154cb5407b7bfa5', // HAIR
  '0xb0557906c617f0048a700758606f64b33d0c41a6', // Zepe.io (it has 2 addresses, true scam)
  '0x5190b01965b6e3d786706fd4a999978626c19880', // EVER
  '0x442b656f5a5c3dd09790951810c5a15ea5295b51', // Tu7.org
  '0x27b880865395da6cda9c407e5edfcc32184cf429', // Dex88.org
];

interface IBalanceMenu {
  error: boolean;
  balances: any;
  mapping: any;
  network: Network;
  rates: any;
  loading: boolean;
  onClose(): void;
}

const filterScam = (coins: string[], mapping: any) =>
  coins.filter(
    (item) => mapping[item] && !scamAddresses.includes(mapping[item]?.contract)
  );

/**
 * Render fallback icon
 * @param param0
 * @returns
 */
const FallbackCoinIcon = ({ name }: any) => {
  return <div className='token__fallback'>{name[0]}</div>;
};

/**
 * Render balances
 * @param mapping, balances
 * @returns
 */

interface IProps {
  mapping: IObject;
  chain: string;
  onClose(): void;
}

type IObject = {
  [key: string]: { [key: string]: string };
};
const Balances = ({ mapping, chain, onClose }: IProps) => {
  return (
    <div className='balances_coins_list'>
      {filterScam(Object.keys(mapping), mapping).map((item, index) => (
        <div key={item + index} className='balances_coins_list__item'>
          <Link
            onClick={onClose}
            to={`/en/token/${chain}/${mapping[item].contract}`}
            className={`balances_coins_list__item__link ${
              mapping[item].isNative
                ? 'balances_coins_list__item__link--disabled'
                : ''
            }`}
          >
            <FallbackImage
              size='s'
              src={mapping[item].icon}
              fallback={<FallbackCoinIcon name={item} />}
            />
            <span title={item} className='text text--14 balance_menu__from'>
              {item}
            </span>
          </Link>
          <Text
            size={14}
            className='balances_coins_list__item__balance text--grey-400'
          >
            {toFixed4(mapping[item].balance)}
          </Text>
        </div>
      ))}
    </div>
  );
};

const BalanceMenu = ({
  error,
  balances,
  network,
  mapping,
  loading,
  onClose,
}: IBalanceMenu) => {
  const ktnBalance = balances['KTN'] || 0;

  /**
   * Navigate to BSC pair when BSC network selected
   */
  const buyKTN = () => {
    if (network.isBSC()) {
      switchCurrentTicker({
        chain: 'BSC',
        address: '0x48028De4A9b0d3D91180333d796021ec7757bA1B',
      });
    } else {
      switchCurrentTicker({
        chain: 'ETH',
        address: '0x92dBB765f587F6E16C07C799E0dB6A1f3AF498B8',
      });
    }
  };

  return (
    <div className='balance_menu'>
      <PricingPlans balance={ktnBalance} onBuy={buyKTN} />
      {loading && <div className='loader' />}
      {!loading && (
        <Balances
          mapping={mapping}
          chain={network.getSymbol()}
          onClose={onClose}
        />
      )}
      {error && (
        <Text size={14} className='warning'>
          Could not fetch balance of your wallet
        </Text>
      )}
    </div>
  );
};

export default BalanceMenu;
